import { render, staticRenderFns } from "./PortAdminRequestSubmittedOverlay.vue?vue&type=template&id=412e05f0&scoped=true"
import script from "./PortAdminRequestSubmittedOverlay.vue?vue&type=script&lang=js"
export * from "./PortAdminRequestSubmittedOverlay.vue?vue&type=script&lang=js"
import style0 from "./PortAdminRequestSubmittedOverlay.vue?vue&type=style&index=0&id=412e05f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412e05f0",
  null
  
)

export default component.exports